module.exports = __webpack_public_path__ + "img/bank-bri.cf0bee72.png";